import SearchBar from './SearchBar';

export { type SearchBarProps } from './SearchBar';
export default SearchBar;
